import { NotificationOutlined } from "@ant-design/icons";
import { Button, Card, Flex, Form, Input, Typography } from "antd";

const { Text, Title, Paragraph } = Typography;
const { TextArea } = Input;

interface Announcement {
  id: string;
  title: string;
  date: string;
  message: string;
}

const mockAnnouncements: Announcement[] = [
  {
    id: "1",
    title: 'New lesson added: "Design System Basics"',
    date: "Jan 12, 2025",
    message:
      "We've added a new module covering components, variants, and responsive layout techniques.",
  },
  {
    id: "2",
    title: 'New lesson added: "Advanced Prototyping Techniques"',
    date: "Feb 5, 2025",
    message:
      "This module dives into interactive prototypes and user testing strategies.",
  },
  {
    id: "3",
    title: 'New lesson added: "Advanced Prototyping Techniques"',
    date: "Feb 5, 2025",
    message:
      "This module dives into interactive prototypes and user testing strategies.",
  },
  {
    id: "4",
    title: 'New lesson added: "Advanced Prototyping Techniques"',
    date: "Feb 5, 2025",
    message:
      "This module dives into interactive prototypes and user testing strategies.",
  },
  {
    id: "5",
    title: 'New lesson added: "Accessibility in Design"',
    date: "Mar 15, 2025",
    message:
      "Explore best practices for creating inclusive and accessible digital experiences.",
  },
];

export default function Announcements() {
  const [form] = Form.useForm();

  const onFinish = (values: { title: string; message: string }) => {
    console.log("Announcement created:", values);
    form.resetFields();
  };

  return (
    <div className="space-y-6">
      {/* Create Announcement Form */}
      <Card className="shadow-sm bordered-card custom-card">
        <div className="mb-6">
          <Title level={4} className="!mb-1 text-theme-slate-800">
            Create Announcement
          </Title>
          <Text className="text-theme-slate-500">
            Send updates, share new lessons, or notify all your learners at once
          </Text>
        </div>

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label={
              <Text className="font-semibold text-theme-slate-700">
                Announcement Title
              </Text>
            }
            name="title"
            rules={[{ required: true, message: "Please enter a title" }]}
          >
            <Input
              placeholder="Enter announcement title"
              size="large"
              className="rounded-lg"
            />
          </Form.Item>

          <Form.Item
            label={
              <Text className="font-semibold text-theme-slate-700">
                Message
              </Text>
            }
            name="message"
            rules={[{ required: true, message: "Please enter a message" }]}
          >
            <TextArea
              placeholder="Write your message here"
              autoSize={{ minRows: 3, maxRows: 6 }}
              className="rounded-lg"
            />
          </Form.Item>

          <Flex gap={12}>
            <Button
              size="large"
              className="rounded-lg min-w-[100px]"
              onClick={() => form.resetFields()}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="rounded-lg min-w-[100px] bg-theme-slate-900 border-none"
            >
              Save
            </Button>
          </Flex>
        </Form>
      </Card>

      {/* Announcement History */}
      <div className="space-y-4">
        <div>
          <Title level={4} className="!mb-1 text-theme-slate-800">
            Announcement History
          </Title>
          <Text className="text-theme-slate-500">
            View and manage your previous announcements
          </Text>
        </div>

        <div className="space-y-3">
          {mockAnnouncements.map((item) => (
            <Card
              key={item.id}
              className="shadow-sm bordered-card hover:border-blue-100 transition-colors"
              bodyStyle={{ padding: "16px 20px" }}
            >
              <Flex gap={20}>
                <div className="mt-1 flex-shrink-0">
                  <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-white">
                    <NotificationOutlined className="text-lg" />
                  </div>
                </div>
                <div className="flex-grow">
                  <Flex justify="space-between" align="start" className="mb-1">
                    <Title
                      level={5}
                      className="!mb-0 text-theme-slate-800 font-bold"
                    >
                      {item.title}
                    </Title>
                    <Text className="text-theme-slate-400 text-sm">
                      {item.date}
                    </Text>
                  </Flex>
                  <Paragraph className="text-theme-slate-600 !mb-0 max-w-[80%] line-clamp-2">
                    {item.message}
                  </Paragraph>
                </div>
              </Flex>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
